/**
 * 年计划考核表动态版本
 */
<template>
  <div class='year atb-flex atb-flex-column'>
    <div class='header atb-flex atb-flex-items-center'>
      <div class='year-title'>
        <h2 v-if="summaryData.year">{{ summaryData.year }}{{ periods[summaryData.period] }} / {{ summaryData.wkName }}</h2>
        <span class="saveStatus">{{ saveStatus }}</span>
      </div>
    </div>
    <div class='container search-and-content atb-content-bg atb-flex atb-flex-column' id="year-wrap">
      <div class="search">
        <div class="function atb-flex">
          <!-- <el-form :inline="true" class="atb-input">
            <el-form-item v-if="isEditable && !isPublished">
              <el-button :disabled="pending" type="primary" @click="saveAll">保存</el-button>
            </el-form-item>
            <el-form-item>
              <el-button plain type="downloadTemplate" @click="expandRowContentAll">{{expandRowContentAllFlag ? "收起全部" : "展开全部"}}</el-button>
            </el-form-item>
          </el-form> -->
        </div>
      </div>
      <div class='table-content atb-flex atb-flex-column'>
        <div v-show="showCollapse" class="collapse" @click="collapse($refs.yearTable, tableColumn)">
          <i :class="[isCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
        </div>
        <vxe-table
          class='atb-table header-table edit-table border-table disable-ellipsis'
          border='full'
          height='100%'
          auto-resize
          resizable
          row-key="id"
          :data="tableData"
          ref="yearTable"
          :row-class-name="setRowClass"
          :edit-config="{trigger: 'click', mode: 'row', activeMethod: editActived}"
          @edit-closed="editClosed"
          @edit-actived="activeRow"
          @cell-click="expandRowContent"
          :edit-rules="validRules"
          :spanMethod="mergeMethod"
          :tree-config="{indent: 0, iconOpen: 'icon-arrow-up-bold', iconClose: 'icon-arrow-down-bold-copy', expandAll: true, }"
        >
          <vxe-table-column field="tree" width='0' max-width="0" tree-node>
            <template #default="{row}">
              <div v-if="row.isClassifyRow" class='classify-row-col atb-flex atb-flex-justify-between atb-flex-items-center'>
                <div class="classify-wrap">
                  <span class="classify-name" @click.stop="expandThisRow(row)">
                    <span v-if="row.children.length === 0" class="empty-children-expand-icon">
                      <i :class="[row.emptyChildrenExpand ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy']" @click.stop="emptyChildrenExpandHandler(row)"></i>
                    </span>
                    <span>{{ row.classifyName }}</span>
                  </span>
                </div>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemNo" min-width="50" title="NO." align="center">
            <template #default="scope">
              <span>{{seqMethod(scope)}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemCategory" min-width="80" title="类别" :edit-render="{name: 'ElAutocomplete', autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.workItemCategory}}</div>
            </template>
            <template #edit="{ row }">
              <el-autocomplete v-model="row.workItemCategory" type="textarea" :autosize="{ maxRows: 8 }" :fetch-suggestions="queryCategory" >
                <template slot-scope="{ item }">
                  <el-tooltip
                    class="item"
                    effect='dark'
                    :content="item.value"
                    placement="right-start"
                  >
                    <div class="query-item-text atb-ellipsis">{{ item.value }}</div>
                  </el-tooltip>
                </template>
              </el-autocomplete>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemContent" title="工作项目" min-width="100" width="150" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.workItemContent" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
            <template #default="scope">
              <div :class="[scope.row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{scope.row.workItemContent}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="fullTarget" min-width="100" title="全年目标" width="150" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.fullTarget}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.fullTarget" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>
           <vxe-table-column field="resWkName" min-width="120" title="责任人(工号)">
            <template #default="{ row }">
              <span>{{ row.resWkName }}</span>
              <span>({{ row.resWkNo }})</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="weight" min-width="80" title="权重(%)" :edit-render="{autofocus: '.el-input__inner'}">
            <template #edit="{ row }">
              <el-autocomplete v-model.number="row.weight" :fetch-suggestions="querySearchWeight" :min="1" @change="validateWeight(row)" oninput="value=value.replace(/[^\.\d]/g,'')"></el-autocomplete>
            </template>
            <template #default="{ row }">
              <span>{{row.weight}}</span>
            </template>
          </vxe-table-column>

          <vxe-table-column field="startDate" title="开始日期" min-width="100" :edit-render="{autofocus: '.el-input__inner'}">
            <template #edit="{ row }">
              <el-date-picker v-model="row.startDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{ formatDate(row.startDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>

          <vxe-table-column field="finishDate" title="最终完成日期" min-width="120" :edit-render="{autofocus: '.el-input__inner'}">
            <template #edit="{ row }">
              <el-date-picker v-model="row.finishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>

          <vxe-table-column field="target" min-width="120" title="上半年目标" width="150" v-if="summaryData.period === 6.5" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.target}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.target" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>

          <vxe-table-column field="summary" min-width="120" title="上半年总结" width="150" v-if="summaryData.period === 6.5" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.summary}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.summary" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>

          <vxe-table-column field="target" min-width="100" title="全年目标" width="150" v-if="summaryData.period === 13" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.target}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.target" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>

          <vxe-table-column field="summary" min-width="100" title="全年总结" width="150" v-if="summaryData.period === 13" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.summary}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.summary" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>

          <vxe-table-column field="appraise" min-width="200" title="评价" :edit-render="{enabled: enabledAppraise, autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.appraise}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.appraise" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>

          <vxe-table-column
            min-width="140"
            field="score"
            :controls="false"
            title="评分"
            :edit-render="{ enabled: enabledScore, autofocus: '.el-input__inner' }"
          >
            <template #edit="{ row }">
              <el-autocomplete @change="regScore(row, 'score')" v-model.trim="row.score" :fetch-suggestions="scoreSearch"></el-autocomplete>
            </template>
            <template #header="{ column }">
              <div style="display: inline-block;">
                <span>{{ column.title }}</span>
                <span>(</span>
                <el-popover
                  width="600"
                  trigger="hover"
                  :popper-options="{removeOnDestroy: true}"
                >
                  <span slot="reference" class="rank-tip">评分标准</span>
                  <table class="rank-tip-table">
                    <thead>
                      <tr>
                        <th width="60" align="center">标准</th>
                        <th width="80" align="center">分值区间</th>
                        <th align="center">标准说明</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td align="center">出色</td>
                        <td align="center">100</td>
                        <td>工作绩效始终超越本职位常规标准要求，通常具有下列表现：在规定的时间之前完成任务，完成任务的数量、质量等明显超出规定的标准，得到来自客户的高度评估。</td>
                      </tr>
                      <tr>
                        <td align="center">优良</td>
                        <td align="center">90</td>
                        <td>工作绩效经常超出本职位常规标准要求，通常具有下列表现：严格按照规定的时间要求完成任务并经常提前完成任务，经常在数量、质量上超出规定的标准，获得客户的满意。</td>
                      </tr>
                      <tr>
                        <td align="center">可接受</td>
                        <td align="center">80</td>
                        <td>工作绩效经常维持或偶尔超出本职位常规标准要求，通常具有下列表现；基本上达到规定的时间、数量、质量等工作标准，没有客户不满。</td>
                      </tr>
                      <tr>
                        <td align="center">需改进</td>
                        <td align="center">70</td>
                        <td>需改进，工作绩效基本维持或偶尔未达本职位常规标准要求，通常具有下列表现：偶有小的疏漏，有时在时间、数量、质量上达不规定的工作标准，偶尔有客户的投诉。</td>
                      </tr>
                      <tr>
                        <td align="center">不良</td>
                        <td align="center">60<br/>30<br/>0</td>
                        <td>工作绩效显著低于常规本职位正常工作标准的要求，通常具有下列表现：工作中出现大的失误，或在时间、数量、质量上达不到规定的工作标准，经常突击完成任务、经常有投诉发生。</td>
                      </tr>
                    </tbody>
                  </table>
                </el-popover>
                <span>)</span>
              </div>
            </template>
          </vxe-table-column>

          <vxe-table-column
            min-width="140"
            field="weightMultiplyScore"
            :controls="false"
            title="得分"
            :edit-render="{ enabled: enabledWeightScore, autofocus: '.el-input__inner' }"
            class-name="weight-score"
          >
            <template #edit="{ row }">
              <el-autocomplete @change="regScore(row, 'weightMultiplyScore')" v-model.trim="row.weightMultiplyScore" :fetch-suggestions="scoreSearch"></el-autocomplete>
            </template>
            <template #header="{ column }">
              <div style="display: inline-block;">
                <span>{{ column.title }}</span>
                <span>(</span>
                <el-popover
                  width="600"
                  trigger="hover"
                  :popper-options="{removeOnDestroy: true}"
                >
                  <span slot="reference" class="rank-tip">评分标准</span>
                  <table class="rank-tip-table">
                    <thead>
                      <tr>
                        <th width="60" align="center">标准</th>
                        <th width="80" align="center">分值区间</th>
                        <th align="center">标准说明</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td align="center">出色</td>
                        <td align="center">100</td>
                        <td>工作绩效始终超越本职位常规标准要求，通常具有下列表现：在规定的时间之前完成任务，完成任务的数量、质量等明显超出规定的标准，得到来自客户的高度评估。</td>
                      </tr>
                      <tr>
                        <td align="center">优良</td>
                        <td align="center">90</td>
                        <td>工作绩效经常超出本职位常规标准要求，通常具有下列表现：严格按照规定的时间要求完成任务并经常提前完成任务，经常在数量、质量上超出规定的标准，获得客户的满意。</td>
                      </tr>
                      <tr>
                        <td align="center">可接受</td>
                        <td align="center">80</td>
                        <td>工作绩效经常维持或偶尔超出本职位常规标准要求，通常具有下列表现；基本上达到规定的时间、数量、质量等工作标准，没有客户不满。</td>
                      </tr>
                      <tr>
                        <td align="center">需改进</td>
                        <td align="center">70</td>
                        <td>需改进，工作绩效基本维持或偶尔未达本职位常规标准要求，通常具有下列表现：偶有小的疏漏，有时在时间、数量、质量上达不规定的工作标准，偶尔有客户的投诉。</td>
                      </tr>
                      <tr>
                        <td align="center">不良</td>
                        <td align="center">60<br/>30<br/>0</td>
                        <td>工作绩效显著低于常规本职位正常工作标准的要求，通常具有下列表现：工作中出现大的失误，或在时间、数量、质量上达不到规定的工作标准，经常突击完成任务、经常有投诉发生。</td>
                      </tr>
                    </tbody>
                  </table>
                </el-popover>
                <span>)</span>
              </div>
            </template>
          </vxe-table-column>

          <vxe-table-column field="remark" min-width="200" title="备注" :edit-render="{enabled: enabledRemark, autofocus: '.el-textarea__inner'}">
            <template #default="{row, rowIndex}">
              <div :class="[row.expandRowContentFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.remark}}</div>
            </template>
            <template #edit="{ row }">
              <el-input type='textarea' :autosize="{maxRows: 8}" placeholder="请输入内容" v-model="row.remark" :maxlength="$config.input.textareaMaxLength"></el-input>
            </template>
          </vxe-table-column>

          <vxe-table-column field="" title="操作" fixed="right" width="100" class-name="operation" :edit-render="{enabled: false}">
            <template #default="scope">
              <div v-if="!scope.row.isClassifyRow">
                <el-tooltip class="item" effect="dark" content="保存" placement="bottom">
                  <i v-throttle class="icon-baocun" @click.stop="saveEditRow(scope.row, scope.rowIndex)"></i>
                </el-tooltip>

                <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                  <i v-throttle class="icon-close delete" @click.stop="deleteData(scope.row, scope.rowIndex)"></i>
                </el-tooltip>
              </div>
              <div v-else class="kpi-add">

              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
  </div>
</template>
<script>
  import qs from 'qs'
  import XEUtils from 'xe-utils'
  import _ from 'lodash';
  import { PERIODS } from '@/utils/period-enum.js';
  import routeMixin from '@/mixins/route.mixin'

  export default {
    name: "workscoreYearDetail",
    mixins: [routeMixin],
    data() {
      const workItemContent = ({cellValue}) => {
        if (!cellValue) {
          return new Error('"工作项目"为必填项')
        }
      }
      const fullTarget = ({cellValue}) => {
        if (!cellValue) {
          return new Error('"全年目标"为必填项')
        }
      }
      const weight = ({cellValue}) => {
        if (!cellValue) {
          return new Error('"权重"为必填项')
        }
      }
      const startDate = ({cellValue, row}) => {
        if (!cellValue) {
          return new Error('"开始日期"为必填项')
        }
        else{
          if(row.finishDate){
             if(XEUtils.timestamp(cellValue)>XEUtils.timestamp(row.finishDate)){
                return new Error('开始日期不能大于最终完成日期')
             }
          }
        }
      }
      const finishDate = ({cellValue, row}) => {
        if (!cellValue) {
          return new Error('"最终完成日期"为必填项')
        }else{
          if(row.startDate){
             if(XEUtils.timestamp(cellValue)<XEUtils.timestamp(row.startDate)){
                return new Error('最终完成日期不能小于开始日期')
             }
          }
        }
      }
      const firstHalfTarget = ({cellValue}) => {
        if (!cellValue) {
          return new Error('"目标"为必填项')
        }
      }
      
      const firstHalfSummary = ({cellValue}) => {
        if (!cellValue) {
          return new Error('"年总结"为必填项')
        }
      }
      
      const appraiseValid = ({cellValue, rowIndex}) => {
        if (rowIndex > 0 && rowIndex <= this.kpiLength && !cellValue) {
          return new Error('"评价"为必填项');
        }
      };
      const scoreValid = ({cellValue, rowIndex}) => {
        if (rowIndex > 0 && rowIndex <= this.kpiLength && !cellValue && cellValue !== 0) {
          return new Error('"评分"为必填项');
        }
      };
      const weightScoreValid = ({cellValue, rowIndex}) => {
        if (rowIndex === this.kpiLength + 1 && !cellValue && cellValue !== 0) {
          return new Error('"得分"为必填项');
        }
      };
      return {
        toUrl: '',
        periods: PERIODS,
        validRules: {
          workItemContent: [
            { required: true,validator: workItemContent, message:'"工作项目"为必填项' }
          ],
          fullTarget: [
            { required: true,validator: fullTarget, message:'"全年目标"为必填项' }
          ],
          weight: [
            { required: true,validator: weight, message:'"权重"为必填项' }
          ],
          startDate: [
            { required: true,validator: startDate, message:'"开始日期"为必填项' }
          ],
          finishDate: [
            { required: true,validator: finishDate, message:'"最终完成日期"为必填项' }
          ],
          target: [
            { required: true,validator: firstHalfTarget, message:'"目标"为必填项' }
          ],
          summary: [
            { required: true,validator: firstHalfSummary, message:'"总结"为必填项' }
          ],
          appraise: [
            { required: true, validator: appraiseValid,  message: '"评价"为必填项' }
          ],
          score: [
            { required: true, validator: scoreValid,  message: '"评分"为必填项' }
          ],
          weightMultiplyScore: [
            { required: true, validator: weightScoreValid,  message: '"得分"为必填项' }
          ],
        },
        summaryData: {},
        workId: '',
        childIds: "",

        workClassifyData: null,

        enabledAppraise: true,
        enabledScore: true,
        enabledWeightScore: true,
        enabledRemark: true,
 
        enabled: true,
 
        result: {},

        status: 0,

        tableColumn: [],

        totalScore: {},

        cloneTableData: [],
        row: {},
        rowIndex: 0,
        editStatus:'',
        saveStatus:'',
        timeoutSave:'',
        timeoutAutoSave:'',
        isCollapse: false,
        showCollapse: false,
        pending: false,
        expandRowAllFlag: false,

        scoreList: [{ value: 100 }, { value: 90 }, { value: 80 }, { value: 70 }, { value: 60 }, { value: 30 }, { value: 0 }],
        tableData: [],
        expandRowContentAllFlag: false,
      }
    },
    computed: {
      tableColumnLength() {
        return this.tableColumn.length;
      },

      isApprove() {
        // 上级进行评分
        return this.editStatus === 'approve';
      },
      isEditable() {
        return this.isApprove && [0, 10, 30].includes(this.status);
      },

      isPublished() {
        return this.status === 50;
      },

      isCanBack() {
        return this.status === null || !this.isApprove || [20, 40, 50].includes(this.status);
      }
      // 已保存0，已引入10，上级已确认20，外部已确认30，已确认40，已公示50
    },
    watch: {
 
    },
    created() {
      this.workId = this.$route.query.id || '';
      this.status = parseInt(this.$route.query.status) || 0;
      this.editStatus = this.$route.query.editStatus || '';
      this.msgId = this.$route.query.msgId || null;
      this.childIds = this.$route.query.childIds? this.$route.query.childIds.split(','): null;
      this.from = this.$route.query.from || '';
      this.workId && this.getList();
    },
    mounted(){
      this.getColumn();
    },
    methods: {
      getColumn() {
        this.$nextTick(() => {
          this.tableColumn = (this.$refs.yearTable && this.$refs.yearTable.getColumns()) || [];
          this.$refs.yearTable && this.$refs.yearTable.refreshColumn();
        });
      },
      regScore(row, score) {
        let val = row[score];
        if(!val) val = '';
        val = val.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        val = val && parseFloat(val);
        if (val - 0 > 100) {
          val = 100;
        }
        if (val - 0 < 0) {
          val = 0;
        }
        if (val === '') val = null;
        row[score] = val;
      },
      scoreSearch(queryString, cb) {
        let programList = this.scoreList;
        // 调用 callback 返回建议列表的数据
        cb(programList);
      },
      collapse(el) {
        this.isCollapse = !this.isCollapse;
        if (this.isCollapse) {
          el && el.refreshColumn();
        }else {
          el && el.refreshColumn();
        }
      },
      getAllChildrenRow() {
        const data = [];
        this.tableData.forEach(row => {
          const children = row.children || [];
          data.push(...children)
        })
        return data;
      },
      expandRowContentAll() {
        const tableDataFlat = this.getAllChildrenRow(this.tableData);
        if (this.expandRowContentAllFlag) {
          tableDataFlat.forEach(val => {
            val.expandRowContentFlag = false;
          }); 
        } else {
          tableDataFlat.forEach(val => {
            val.expandRowContentFlag = true;
          });
        }
        this.expandRowContentAllFlag = !this.expandRowContentAllFlag;
        this.$refs.yearTable.updateData(this.tableData);

        this.$nextTick(() => {
          let scrollInfo = this.$refs.yearTable.getScroll();
          this.$refs.yearTable.scrollTo(scrollInfo.scrollLeft, scrollInfo.scrollTop + 1);
        });
      },

      async getList() {
        // 保存当前状态
        let param = Object.assign({ScoreId: this.workId})
        await this.$ajax.get(this.$api.period.workScore.yearScoreList +'?'+ qs.stringify(param, {indices: false})).then((res) => {

          const rows = res.data.listReturnDtos || [];
          let totalScore = {};
          rows.forEach(item => {
            item.id = 'workClassify_' + item.workClassify;
            item.parentId = null;
            item.isClassifyRow = true;
            item.isChecked = false;
            item.emptyChildrenExpand = true;
            item.weightMultiplyScore = item.score;
            totalScore[item.workClassify] = item.score;
            item.score = null;
            item.yearItemScoreEntities.forEach(r => {
              r.classifyType = item.classifyType;
            });
            if (item.classifyType !== 1) {
              // type不为1的，合并评价、评分、得分、备注
              // 将总的评价、备注添加给每一行
              const childrenLength = item.yearItemScoreEntities.length;
              item.yearItemScoreEntities.forEach((r, index) => {
                if (index === 0) {
                  r.isFristRow = true;
                  r.rowspan = childrenLength;
                } else {
                  r.isFristRow = false;
                  r.rowspan = 0;
                }
                r.appraise = item.appraise;
                r.remark = item.remarks;
                r.expandRowContentFlag = false;
                r.isChecked = false;
                r.parentId = item.id;
              });
            }
            item.children = item.yearItemScoreEntities || [];
          });
          this.totalScore = totalScore;

          this.tableData = rows;
          this.cloneTableData = _.cloneDeep(rows);
          this.summaryData = res.data.yearScoreEntity;
          this.status = this.summaryData.status;
          this.getColumn();
        }).catch((e)=>{
          console.error(e);
          this.status = null;
        }).finally(() => {
          this.expandAll();
        });
      },
 
      seqMethod({row, seq}) {
        let seqNumber = 0;
        let treeSeq = seq && typeof seq === 'string' ? seq.split('.') : (row.seq || '').split('.');
        seqNumber = treeSeq[1];
        return seqNumber || row.workItemNo;
      },
      formatDate(value, format) {
        return XEUtils.toDateString(value, format)
      },

      saveFn(row) {
        this.pending = true;
        // 重要KPI 每项
        
        if (!row.isClassifyRow) {
          if (row.classifyType === 1) {
            return this.$ajax.post(this.$api.period.manage.updateYearWorkItem,  row, {noLoading:true}).then((res) => {
              if (res.data && res.data.yearItemScore) {
                const item = res.data.yearItemScore;
                row.weightMultiplyScore = item.weightMultiplyScore;
              }
              if (res.data && res.data.periodClassifyScoreEntities) {
                const workClassifyItems = res.data.periodClassifyScoreEntities || [];
                const workClassifyItem = workClassifyItems.find(item => item.workClassify === 0);

                this.totalScore[workClassifyItem.workClassify] = workClassifyItem.score;
                const type1Rows = this.tableData.filter(item => item.isClassifyRow && item.classifyType === 1);
                if (type1Rows && type1Rows.length > 0) {
                  type1Rows[0].weightMultiplyScore = workClassifyItem.score;
                }
              }
            }).finally(()=>{
              this.pending = false;
            });
          } else {
            
            // 每个分类的第一行负责评价、备注的编辑
            if (row.isFristRow) {
              let params = {
                "wkNo": this.summaryData.wkNo,
                "wkName": this.summaryData.wkName,
                "year": this.summaryData.year,
                "period": this.summaryData.period,
                "workClassify": row.workClassify,
                "score": null,
                "appraise": row.appraise,
                "remarks": row.remark
              };
              // 找到workClassify对应的分类行，即当前行的父级
              const workClassifyRow = this.tableData.find(r => r.isClassifyRow && row.workClassify === r.workClassify);
              params.score = workClassifyRow ? workClassifyRow.weightMultiplyScore : null;

              this.$ajax.post(this.$api.period.manage.updateYearScore, [params], {noLoading:true}).finally(()=>{
                this.pending = false;
              });
            }
            return this.$ajax.post(this.$api.period.manage.updateYearWorkItem,  row, {noLoading:true}).finally(()=>{
              this.pending = false;
            });
          }
          
        } else if (row.classifyType !== 1) {
          // 除KPI外 得分
          let params = {
            "wkNo": this.summaryData.wkNo,
            "wkName": this.summaryData.wkName,
            "year": this.summaryData.year,
            "period": this.summaryData.period,
            "workClassify": row.workClassify,
            "score": null,
          };

          let rowChildren = row.children;
          params.score = row.weightMultiplyScore;
          params.appraise = rowChildren[0] ? rowChildren[0].appraise : '';
          params.remarks = rowChildren[0] ? rowChildren[0].remark : '';
          this.totalScore[params.workClassify] = params.score;
          return this.$ajax.post(this.$api.period.manage.updateYearScore, [params], {noLoading:true}).finally(()=>{
            this.pending = false;
          });
        }
      },

      save(row) {
        this.saveFn(row).then(() => {
          this.saveStatus = "已保存";
          this.timeoutSave && clearTimeout(this.timeoutSave);
          this.timeoutSave = setTimeout(()=>{
            this.saveStatus = "";
          }, 1000, this);
          this.$nextTick(() => {
            this.cloneTableData = _.cloneDeep(this.tableData);
          })
        }).catch(e => {
          console.error(e);
        });
      },

      saveAll() {
        const type1Rows = this.tableData.filter(item => item.isClassifyRow && item.classifyType === 1);
        const type1RowChildren = [];
        type1Rows.forEach(r => {
          type1RowChildren.push(...r.children);
        });

        const type0Rows = this.tableData.filter(item => item.isClassifyRow && item.classifyType === 0);
        const type0RowChildren = type0Rows && type0Rows.length > 0 ? type0Rows[0].children : [];
        if (type1RowChildren.length === 0 && type0RowChildren.length === 0) {
          return this.$message.warning('当前没有需要保存的数据');
        }
        if (type1RowChildren.length > 0) {
          this.$ajax.post(this.$api.period.workScore.yearScoreUpdate,  type1RowChildren, {noLoading:true}).then((res) => {
            if (res.code == 0){
              this.$message.success('保存成功');
            } else {
              this.$message.error(res.message);
            }
          });
        }
        if (type0RowChildren.length > 0) {
          const params = {
            "wkNo": this.summaryData.wkNo,
            "wkName": this.summaryData.wkName,
            "year": this.summaryData.year,
            "period": this.summaryData.period,
            "workClassify": type0Rows[0].workClassify,
            "score": type0Rows[0].weightMultiplyScore,
            "appraise": type1RowChildren[0].appraise,
            "remarks": type1RowChildren[0].remarks,
          };
  
          this.$ajax.post(this.$api.period.workScore.updateYearScore, params, {noLoading:true})
        }
      },
      
      editClosed({row}) {
        this.enabledAppraise = true;
        this.enabledScore = true;
        this.enabledWeightScore = true;
        this.enabledRemark = true;
        
        if (!(row.classifyType === 1 && row.isClassifyRow)) {
          if(this.$getRowExpandFlag()) row.expandRowContentFlag = false;
          this.$refs.yearTable.updateData(this.tableData);
          this.saveEditRow(row);
        }
      },
      activeRow() {
        
      },

      editActived({row}) {
        // 可编辑状态
        if (!row.isClassifyRow && row.classifyType === 1) {
          this.enabledScore = true;
        } else {
          this.enabledScore = false;
        }

        if (row.isClassifyRow && row.classifyType !== 1 && row.children.length > 0) {
          this.enabledWeightScore = true;
        } else {
          this.enabledWeightScore = false;
        }

        if (!row.isClassifyRow) {
          this.enabledAppraise = true;
          this.enabledRemark = true;
        } else {
          this.enabledRemark = false;
          this.enabledAppraise = false;
        }
        return true;
      },

      findCloneData(row) {
        let result = null;
        const cloneRow = this.cloneTableData.find(item => item.isClassifyRow && item.workClassify === row.workClassify);
        if (row.isClassifyRow) {
          result = _.cloneDeep(cloneRow);
        } else {
          const childRows = cloneRow.children || [];
          result = _.cloneDeep(childRows.find(c => row.id === c.id));
        }
        return result;
      },
      saveEditRow(row) {
        if (this.pending) return 0;
        const originRow = this.findCloneData(row);
        originRow._X_ID = row._X_ID;
        originRow.expandRowContentFlag = row.expandRowContentFlag;
        if (_.isEqual(row, originRow)) {
          this.saveStatus = "已保存";
          this.timeoutSave && clearTimeout(this.timeoutSave);
          this.timeoutSave = setTimeout(()=>{
            this.saveStatus = "";
          }, 1000, this);
          return 0;
        }
        this.pending = true;

        this.$confirm('确定要修改吗', '修改', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }).then(() => {
          this.save(row);
        }).catch(() => {
          this.writeRow(row, originRow);
          this.pending = false;
        });
      },
      writeRow(row, originRow) {
        Object.assign(row, originRow);
      },
      deleteData(row) {
        this.$confirm('确定要删除吗', '删除', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }).then(() => {
          this.$ajax.get(this.$api.period.manage.deleteYearScoreItem + '?id=' + row.id).then(() => {
            const classifyRow = this.tableData.find(r => r.isClassifyRow && r.workClassify === row.workClassify);
            const children = classifyRow.children || [];
            if (row.classifyType === 1) {
              _.remove(children, t => t.id == row.id);
            } else {
              if (row.isFristRow && children[1]) {
                children[1].appraise = row.appraise;
                children[1].remark = row.remark;
                children[1].isFristRow = true;
                children[1].rowspan = row.rowspan - 1;
              }
              _.remove(children, t => t.id == row.id);
            }
            children.splice(0, 0);
            this.$nextTick(() => {
              this.cloneTableData = _.cloneDeep(this.tableData);
            })
            this.$message.success('删除成功');
          });
        })
      },
      setRowClass({row}) {
        if (row.isClassifyRow) {
          return 'classify-row';
        }
      },
      mergeMethod({row, column, columnIndex}) {
        if (row.isClassifyRow) {
          if (columnIndex === 0) {
            return {rowspan: 1, colspan: [6.5, 13].includes(this.summaryData.period) ? this.tableColumnLength - 4 : this.tableColumnLength}
          } else if (columnIndex > 0 && columnIndex < this.tableColumnLength - 4) {
            return {rowspan: 1, colspan: 0 }
          }
        } else if (['appraise', 'score', 'weightMultiplyScore', 'remark'].includes(column.property) && row.classifyType !== 1) {
          // type不为1的，合并评价、评分、得分、备注
          if (row.isFristRow) {
            return {rowspan: row.rowspan, colspan: 1}
          } else {
            return {rowspan: 0, colspan: 1}
          }
        } else {
          return {rowspan: 1, colspan: 1}
        }
      },
      expandThisRow(row) {
        row.emptyChildrenExpand = !row.emptyChildrenExpand;
        this.$refs.yearTable.toggleTreeExpand(row);
      },
      emptyChildrenExpandHandler(row) {
        row.emptyChildrenExpand = !row.emptyChildrenExpand;
      },
      expandAll() {
        this.$refs.yearTable.setAllTreeExpand(true);
      },
      expandRowContent({row, column}) {
        if (column.title === 'NO.') {
          return false;
        }
        if (row.status === 0 || row.status === 30 || (row.status === 10 && this.editStatus === "approve")) {
          if(this.$getRowExpandFlag()) row.expandRowContentFlag = !row.expandRowContentFlag;
          this.$refs.yearTable.updateData(this.tableData);
        } else {
          if(this.$getRowExpandFlag()) row.expandRowContentFlag = !row.expandRowContentFlag;
          this.$refs.yearTable.updateData(this.tableData);
        }
      },
    },
  }
</script>
<style scoped lang='scss'>
  .year {
    height: 100%;
    .header {
      margin-top: -5px;
      .year-title {
        padding: 0 10px;
        line-height: 30px;
        h2 {
          color: $--color-text-primary;
          font-size: 18px;
          font-weight: bold;
          display: inline-block;
        }
        .saveStatus{
          margin-left: 10px;
          font-size: 15px;
          color: #8e9694;
        }
      }
    }
     ::v-deep .el-tag {
      padding: 0 10px;
      width: auto;
      text-align: center;
    }
    ::v-deep .vxe-cell {
      padding-left: 5px;
      padding-right: 5px;
    }    

    .container {
      margin-top: 15px;
      padding: 20px;
      flex: 1;
      .el-icon-arrow-down{
        font-size: 12px;
      }
      .open{
        padding: 8px 0 0 0;
        text-align: right;
        font-size: 14px;
        color: #859291;
        cursor: pointer;
      }
      .table-content{
        position: relative;
        .collapse{
          position: absolute;
          cursor: pointer;
          width: 15px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          background-color: rgba(#000, 0.1);
          z-index: 99;
          &:hover{
            background-color: rgba(#000, 0.2);
          }
          i{
            font-size: 14px;
            color: #fff;
          }
        }
      }
      .search {
        overflow: auto;
        .function{
          flex-wrap: wrap;
        }
        .atb-input{
          display: flex;
          &.search-input{
            padding-top: 8px;
          }
          .flex-form-item{
            margin-bottom: 12px;
            display: flex;
            flex: 1;
          }
          .read-mode{
            align-self: flex-end;
          }
          ::v-deep.el-form-item__content{
            flex: 1;
            .el-select, .el-autocomplete{
              width: 100%;
            }
          }
        }
      }
      .kpi-content {
        overflow: auto;
        flex-grow: 1;
      }
      ::v-deep .header-table {
        overflow: auto;
        flex-grow: 1;
        user-select: text;
        .vxe-table--header-wrapper {
          background-color: $--bg-color-complete !important;
        }
      }
      ::v-deep .classify-row {
        // background-color: $--color-bg-table-header;
        .vxe-cell--placeholder {
          font-size: 0;
        }
        .vxe-cell--checkbox, .vxe-cell {
          padding: 0;
        }
        .vxe-cell {
          background-color: #f6f7fb;
          height: 47px;
        }
        .weight-score .vxe-cell {
          padding-left: 5px;
          padding-right: 5px;
          height: 46px;
          background-color: #fff;
          display: flex;
          align-items: center;
        }
      }
      .vxe-tree-cell {
        padding: 0;
      }
      ::v-deep .vxe-tree--node-btn {
        color: $--color-primary;
      }
      ::v-deep .vxe-tree--btn-wrapper {
        left: 8px;
        top: 42%;
      }
      ::v-deep .classify-row-col {
        height: 47px;
        color: $--color-primary;
        font-size: 14px;
        .classify-wrap {
          margin-left: 10px;
          cursor: pointer;
          .classify-name {
            margin-right: 15px;
          }
        }
        .empty-children-expand-icon {
          position: absolute;
          left: -23px;
          top: -1px;
        }
        .classify-name {
          position: relative;
          user-select: none;
          cursor: pointer;
        }
      }
    }
    
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
    ::v-deep .el-input-group__append {
      padding: 0 5px;
    }
  }
   ::v-deep .el-radio-button {
    margin-right: 20px;
    margin-bottom: 15px;
    .el-radio-button__inner {
      border-radius: 20px;
      padding: 0 20px;
      width: 100%;
      line-height: 36px;
      border: 1px solid $--color-primary;
      color: $--color-primary;
    }
  }
  ::v-deep .el-radio-button.is-active .el-radio-button__inner {
    color: $--color-white;
  }
  
  .program-check {
    li {
      &:not(:last-child) {
        padding-bottom: 20px;
      }
      .el-checkbox__label {
        span {
          font-weight: bold;
        }
      }
      div {
        flex-grow: 1;
        margin-left: 15px;
        p {
          color: $--color-text-primary;
          font-size: 14px;
          &.desc {
            line-height: 1.5;
          }
          &.date {
            line-height: 1;
            margin-top: 10px;
          }
        }
      }
    }
  }
  .rank-tip {
    color: $--color-primary;
  }
  .rank-tip-table {
    border-collapse: collapse;
    font-size: 13px;
    color: #222;
    td, th {
      padding: 10px ;
      border: 1px solid #ccc;
    }
  }
  .footer {
    text-align: right;
    margin-top: 20px;
    .select-all-program {
      margin-right: 20px;
    }
  }

</style>